import { render } from "./DashboardHome-page.vue?vue&type=template&id=44f52797&scoped=true"
import script from "./DashboardHome-page.vue?vue&type=script&lang=js"
export * from "./DashboardHome-page.vue?vue&type=script&lang=js"

import "./DashboardHome-page.vue?vue&type=style&index=0&id=44f52797&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44f52797"]])

export default __exports__